/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { Col } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import companyTypesOptions from './companyTypeOptions';
import messages from './ManualCompanyAddressDE.messages';
import companySearchMessages from '../../../components/CompanyName/CompanyName.messages';
import FormField from '../../../components/FormField/index';
import { germanPostcodeFormatter } from '../../../helpers/helpers';
import normalizer from '../../../helpers/inputNormalizer';

export class ManualCompanyAddressDE extends React.Component {
    render() {
        const {
            toggle,
            company: { company_name, address, type }
        } = this.props;

        const formattedPostcode = normalizer(
            address.postcode,
            germanPostcodeFormatter,
            null
        );

        return (
            <div>
                <FormField
                    label={
                        <FormattedMessage
                            {...companySearchMessages.companyName}
                        />
                    }
                    field={company_name}>
                    <FormField.Input
                        maxLength={200}
                        onFocus={() => {
                            tracking.ampli.formFieldStarted({
                                form_field: 'manual_company_name'
                            });
                        }}
                        onBlur={(event) => {
                            if (event.target.value.length > 0) {
                                tracking.ampli.formFieldCompleted({
                                    form_field: 'manual_company_name'
                                });
                            }
                        }}
                    />
                </FormField>

                <FormField
                    label={<FormattedMessage {...messages.addressLine1} />}
                    field={address.street_line_1}>
                    <FormField.Input
                        onFocus={() => {
                            tracking.ampli.formFieldStarted({
                                form_field: 'manual_address_line_1'
                            });
                        }}
                        onBlur={(event) => {
                            if (event.target.value.length > 0) {
                                tracking.ampli.formFieldCompleted({
                                    form_field: 'manual_address_line_1'
                                });
                            }
                        }}
                    />
                </FormField>

                <Col xs={12}>
                    <div className="toggle-company-link">
                        <a onClick={toggle}>
                            <FormattedMessage
                                {...companySearchMessages.searchForCompany}
                            />
                        </a>
                    </div>
                </Col>

                <FormField
                    label={<FormattedMessage {...messages.addressLine2} />}
                    field={address.street_line_2}>
                    <FormField.Input
                        onFocus={() => {
                            tracking.ampli.formFieldStarted({
                                form_field: 'manual_address_line_2'
                            });
                        }}
                        onBlur={(event) => {
                            if (event.target.value.length > 0) {
                                tracking.ampli.formFieldCompleted({
                                    form_field: 'manual_address_line_2'
                                });
                            }
                        }}
                    />
                </FormField>

                <FormField
                    label={<FormattedMessage {...messages.buildingNumber} />}
                    field={address.building_number}>
                    <FormField.Input
                        onFocus={() => {
                            tracking.ampli.formFieldStarted({
                                form_field: 'manual_building_number'
                            });
                        }}
                        onBlur={(event) => {
                            if (event.target.value.length > 0) {
                                tracking.ampli.formFieldCompleted({
                                    form_field: 'manual_building_number'
                                });
                            }
                        }}
                    />
                </FormField>

                <FormField
                    label={<FormattedMessage {...messages.postcode} />}
                    field={formattedPostcode}>
                    <FormField.Input
                        maxLength={5}
                        onFocus={() => {
                            tracking.ampli.formFieldStarted({
                                form_field: 'manual_postcode'
                            });
                        }}
                        onBlur={(event) => {
                            if (event.target.value.length > 0) {
                                tracking.ampli.formFieldCompleted({
                                    form_field: 'manual_postcode'
                                });
                            }
                        }}
                    />
                </FormField>

                <FormField
                    label={<FormattedMessage {...messages.town} />}
                    field={address.town}>
                    <FormField.Input
                        onFocus={() => {
                            tracking.ampli.formFieldStarted({
                                form_field: 'manual_town'
                            });
                        }}
                        onBlur={(event) => {
                            if (event.target.value.length > 0) {
                                tracking.ampli.formFieldCompleted({
                                    form_field: 'manual_town'
                                });
                            }
                        }}
                    />
                </FormField>

                <FormField
                    wrapperClassName="company-type-question"
                    label={<FormattedMessage {...messages.companyType} />}
                    field={type}>
                    <FormField.Select
                        onChange={(item) =>
                            type.onChange((item && item.value) || '')
                        }
                        options={companyTypesOptions}
                        value={type.value}
                        placeholder={
                            <FormattedMessage {...messages.legalForm} />
                        }
                        onFocus={() => {
                            tracking.ampli.formFieldStarted({
                                form_field: 'manual_company_type'
                            });
                        }}
                        onBlur={(event) => {
                            if (event.target.value.length > 0) {
                                tracking.ampli.formFieldCompleted({
                                    form_field: 'manual_company_type'
                                });
                            }
                        }}
                    />
                </FormField>
            </div>
        );
    }
}

export default ManualCompanyAddressDE;
